import React from "react";
import PropTypes from "prop-types";
import Header from "components/Admin/shared/Table/Header.jsx";

const titles = {
  webinar_title: "WEBINAR TITLE",
  // sponsor:'SPONSOR',
  email: "EMAIL",
  start_date: "START DATE",
  end_date: "END DATE",
  user_id: "USER TYPE",
  booking_experts: "SPEAKERS",
};

const miniLabel = {
  webinar_title: "webinar_title",
  email: "email",
};

const additionalProps = {
  created_at: {
    revert: true,
  },
  last_login: {
    revert: true,
  },
  start_date: {
    revert: true,
  },
  end_date: {
    revert: true,
  },
  logins: {
    thProps: {
      //colSpan: '2'
    },
    disabled: true,
  },
  name: {
    values: ["webinar_title", "email"],
    miniLabels: miniLabel,
  },
};

function Headers({ onChange, value: selectedValue }) {
  return (
    <tr>
      <th></th>
      {Object.keys(titles).map((value) => (
        <Header
          onChange={onChange}
          key={value}
          values={[value]}
          title={titles[value]}
          selected={selectedValue}
          {...(additionalProps[value] || {})}
        />
      ))}
    </tr>
  );
}

Headers.defaultProps = {};

Headers.propTypes = {};

export default Headers;



// WEBPACK FOOTER //
// ./src/components/Admin/Calendar/ApproveBooking/Headers.jsx